/**
 * @generated SignedSource<<c1ecf6e0d0a2830232af8f54c3bd1348>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomePage_homePage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "analyticsData",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AnalyticsDataTextRow_analyticsData"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSections_page"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Subscription_subscribable"
    }
  ],
  "type": "HomePage",
  "abstractKey": null
};

node.hash = "c861531d0e9c2fcd88a0858cf0d82805";

module.exports = node;
